export default __webpack_public_path__ + "static/media/infografica-legaldesign.68602f1f.svg";